export default __webpack_public_path__ + "static/media/aeroland-slider-software-slide-01.c663bb58.png";